(() => {
  const REMOVE_SELECTOR = '[data-remove-linked-cart-items]';

  let isRemoving = false;

  function getCartRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  function getCartUrl(path) {
    const root = getCartRoot();

    return `${root}${path}`.replace(/\/{2,}/g, '/');
  }

  function getLineProperty(item, propertyName) {
    if (!item || !item.properties) {
      return null;
    }

    const value = item.properties[propertyName];

    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {
      return null;
    }

    return String(value);
  }

  async function getCart() {
    const response = await fetch(
      getCartUrl('cart.js'),
      {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        credentials: 'same-origin'
      }
    );

    if (!response.ok) {
      throw new Error(
        'The basket could not be loaded.'
      );
    }

    return response.json();
  }

  async function updateCart(updates) {
    const response = await fetch(
      getCartUrl('cart/update.js'),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ updates })
      }
    );

    let result = null;

    try {
      result = await response.json();
    } catch {
      result = null;
    }

    if (!response.ok) {
      throw new Error(
        result?.description ||
        result?.message ||
        'The linked basket items could not be removed.'
      );
    }

    return result;
  }

  function findLinkedItems(cart, reference) {
    if (!cart || !Array.isArray(cart.items)) {
      return [];
    }

    return cart.items.filter((item) => {
      const itemReference = getLineProperty(
        item,
        '_lie_angle_reference'
      );

      return itemReference === reference;
    });
  }

  function buildRemovalUpdates(items) {
    return items.reduce((updates, item) => {
      if (item.key) {
        updates[item.key] = 0;
      }

      return updates;
    }, {});
  }

  function setRemoveState(link, isBusy) {
    if (!(link instanceof HTMLElement)) {
      return;
    }

    if (isBusy) {
      link.setAttribute('aria-busy', 'true');
      link.setAttribute('aria-disabled', 'true');

      if (!link.dataset.originalText) {
        link.dataset.originalText =
          link.textContent.trim();
      }

      link.textContent = 'Removing…';
      return;
    }

    link.removeAttribute('aria-busy');
    link.removeAttribute('aria-disabled');

    if (link.dataset.originalText) {
      link.textContent = link.dataset.originalText;
      delete link.dataset.originalText;
    }
  }

  function refreshCart() {
    window.location.reload();
  }

  async function removeLinkedItems(link) {
    const reference =
      link.dataset.lieAngleReference;

    if (!reference) {
      window.location.assign(link.href);
      return;
    }

    const cart = await getCart();

    const linkedItems = findLinkedItems(
      cart,
      reference
    );

    /*
     * There should normally be two lines:
     *
     * 1. The golf club product
     * 2. The lie-angle adjustment product
     */
    if (linkedItems.length === 0) {
      window.location.assign(link.href);
      return;
    }

    const updates =
      buildRemovalUpdates(linkedItems);

    if (Object.keys(updates).length === 0) {
      window.location.assign(link.href);
      return;
    }

    await updateCart(updates);

    refreshCart();
  }

  document.addEventListener(
    'click',
    async (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const link = event.target.closest(
        REMOVE_SELECTOR
      );

      if (!(link instanceof HTMLAnchorElement)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (isRemoving) {
        return;
      }

      isRemoving = true;
      setRemoveState(link, true);

      try {
        await removeLinkedItems(link);
      } catch (error) {
        console.error(
          'Linked cart item removal error:',
          error
        );

        const message =
          error instanceof Error
            ? error.message
            : 'The linked basket items could not be removed.';

        window.alert(message);

        setRemoveState(link, false);
        isRemoving = false;
      }
    },
    true
  );
})();